import React from 'react';
import {
  Button, 
  ImageBoxOne, 
  SecTitle, 
  SecSubTitle, 
  InfoMedia
} from '../../components';

const AboutOne = ({className})=> (
  <div className={`position-relative ${className || ''}`}>    
    <div className="about-shape1 d-none d-xl-block">BayTelecom</div>
    <div className="container z-index-common">        
      <div className="row gx-60">
        <div className="col-lg-6 col-xl-5 mb-50 mb-lg-0">
          <ImageBoxOne imageOne="images/project/bouesti-phone2.jpg"
            imageTwo="images/project/course-reg.png"
            video="images/project/eksucbt.mp4"
          />
        </div>
        <div className="col-lg-6 col-xl-7 align-self-center">
          <SecSubTitle><i className="fas fa-bring-forward"/>Get best education management system</SecSubTitle>
          <SecTitle className="h1">Trust Our Best IT Solution For Your Institution</SecTitle>
          <p className="mb-4 mt-1 pb-3">At Bway Telecom, we deliver powerful digital solutions tailored for educational institutions. Our robust portal systems help schools, colleges, and universities manage students, staff, academics, and exams all in one place. From Learning Management Systems (LMS) to Computer-Based Testing (CBT) and automated admission/payment platforms, we simplify operations and enhance learning.</p>
          <InfoMedia 
            image="images/icon/tel-1-1.png"
            title="24 HOURS SERVICE AVAILABLE"
            info="Call Us: +234 81 344 774 81"
            className="call-media"
          />
          <Button path="/about">About Us<i className="far fa-long-arrow-right"/></Button>
        </div>
      </div>
    </div>    
  </div>
);

export default AboutOne;